import { useState, useEffect } from 'react';
import isLandscape from '../utils/isLandscape';

const useLandscape = (): boolean => {
    const [landscape, setLandscape] = useState<boolean>(isLandscape());

    useEffect(() => {
        const mediaQueryList = window.matchMedia('(orientation: landscape)');

        const listener = (e: MediaQueryListEvent): void => {
            setLandscape(e.matches);
        };

        mediaQueryList.addListener(listener);

        return () => {
            mediaQueryList.removeListener(listener);
        };
    }, []);

    return landscape;
};

export default useLandscape;
